import {connect} from "react-redux";
import {
  changeEndingCenter, changeMainSetting,
  closeDock, assignDock, unlockDock,
  cancelStuart, regularizeStuart,
  cancelUber, regularizeUber,
  cancelWaitingBatch
} from "../../../actions/dock";
import { showUberDirectBatchModal } from "../../../actions/modal";
import { showPopinConfirm } from "../../../../support/actions";
import DockTitle from "./DockTitle";

import { callStuart } from "../../../../../actions";
import {
  processDriverReturn,
  startProcessDriverReturn
} from "../../../../../apps/dispatch/actions/driver";

const mapStateToProps = (state) => {
  return {
    authUser: state.user,
    isUberDirectBatchingEnabled: state.dispatch.metas.uberdirect_batching_enabled,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    "onChangeMainSetting":  (dock, newValue) => dispatch(changeMainSetting(dock, newValue)),
    "onCloseDock":          (dock) => dispatch(closeDock(dock)),
    "onChangeEndingCenter": (dock, newValue) => dispatch(changeEndingCenter(dock, newValue)),
    "onAssignDock":         (dock) => dispatch(assignDock(dock)),
    "onUnlockDock":         (dock) => dispatch(unlockDock(dock)),
    "onCallStuart":         (dock, transportType) => dispatch(callStuart(dock, transportType)),
    "onCancelStuart":       (dock) => dispatch(cancelStuart(dock)),
    "onRegularizeStuart":   (dock) => dispatch(regularizeStuart(dock)),
    "onCancelUber":       (dock) => dispatch(cancelUber(dock)),
    "onRegularizeUber":   (dock) => dispatch(regularizeUber(dock)),
    "onProcessDriverReturn":  (driver) => {
      dispatch(startProcessDriverReturn(driver));
      dispatch(processDriverReturn(driver));
    },
    "onShowUberDirectBatchModal": (dock) => dispatch(showUberDirectBatchModal(dock)),
    "onCancelWaitingBatch": (dock) => dispatch(showPopinConfirm(
      "L'annulation du batch entraîne l'envoi aux clients de SMS Uber d'annulation de livraison, êtes-vous sur de vouloir annuler le batch ?",
      cancelWaitingBatch(dock)
    )),
  };
};


let DockTitleLinked = connect(
  mapStateToProps,
  mapDispatchToProps
)(DockTitle);


export default DockTitleLinked;
